export type EquivalenceHoraire =
  | "UNDEFINED"
  | "SIMPLE"
  | "CONTRAT"
  | "PLANNING_ET_CONTRAT";

export const allEquivalenceHoraire: EquivalenceHoraire[] = [
  "UNDEFINED",
  "SIMPLE",
  "CONTRAT",
  "PLANNING_ET_CONTRAT",
];

export function equivalenceHoraireFromString(
  s: string,
): EquivalenceHoraire | undefined {
  if ((allEquivalenceHoraire as string[]).includes(s)) {
    return s as EquivalenceHoraire;
  }
  console.error(`Unexpected EquivalenceHoraire range: "${s}"`);
}
